module.exports = __webpack_public_path__ + "img/defalut.8c805c24.png";